import { IconButton, SxProps, Theme, Typography } from '@mui/material';
import { BlockHeader, DynamicIcon, Tooltip } from 'src/components';
import { paneHeaderIconButtonSx } from 'src/components/Navbar/navbar.styles';

const mobileHeaderSx: SxProps<Theme> = {
  position: 'sticky',
  top: 0,
  zIndex: (theme) => theme.zIndex.app.ServiceDeskConversationHeader,
  borderBottom: (theme) => `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
};

export const ConversationSidePanelMobileHeader = ({ onBack }: { onBack: () => void }) => (
  <BlockHeader sx={mobileHeaderSx} data-testid="conversation-side-panel-mobile-header">
    <Tooltip title="Back to conversation">
      <IconButton
        disableRipple
        sx={paneHeaderIconButtonSx}
        onClick={onBack}
        data-testid="conversation-side-panel-back"
      >
        <DynamicIcon name="arrow_back" />
      </IconButton>
    </Tooltip>
    <Typography variant="subtitle2" noWrap>
      Details
    </Typography>
  </BlockHeader>
);
